module.exports = __webpack_public_path__ + "r-v3/img/ml_19_00.2d6ad2f4.jpg";